import styled from 'styled-components';

export const Hr = styled('hr')`
  margin: ${({ theme }) => theme.x2spacePx}px 0;
`;
export const MetricWrapper = styled('div')`
  position: relative;
  margin: ${({ theme }) => theme.x2spacePx}px 0 0
    ${({ theme }) => theme.x2spacePx}px;
  p {
    ${({ theme }) => theme.typography.megaStrong}
    &:last-child {
      ${({ theme }) => theme.typography.small}
      margin-bottom: 0;
    }
  }
  &:before {
    content: '';
    display: block;
    position: absolute;
    width: ${({ theme }) => theme.x1spacePx / 2}px;
    height: 100%;
    top: 0;
    background: ${({ theme }) => theme.color.brand01};
    border-radius: 4px;
    margin-left: -${({ theme }) => theme.x2spacePx}px;
  }
`;
